<div class="c-testerModal">
  <div class="c-testerModal__container">
    <slotcom-navigation-button
      type="close"
      topPosition="-0.5"
      rightPosition="-1"
      (click)="closeModal()">
    </slotcom-navigation-button>

    <div class="c-testerModal__title">TESTER MENÚ</div>
    <nav class="c-testerModal__tabs">
      <slotcom-button
        class="c-tab_button"
        [class.active]="activeTab === 'playerOptions'"
        (click)="setPanelTab('playerOptions')">
        Player Options
      </slotcom-button>
      <slotcom-button
        class="c-tab_button"
        [class.active]="activeTab === 'webOptions'"
        (click)="setPanelTab('webOptions')">
        Web Options
      </slotcom-button>
      <slotcom-button
        class="c-tab_button"
        [class.active]="activeTab === 'advancedOptions'"
        (click)="setPanelTab('advancedOptions')">
        Advanced Options
      </slotcom-button>
      <slotcom-button
        class="c-tab_button"
        [class.active]="activeTab === 'playGamesOptions'"
        (click)="setPanelTab('playGamesOptions')">
        Play Games
      </slotcom-button>
    </nav>
    <div class="c-testerModal__content">
      @if (activeTab === 'playerOptions') {
        <slotcom-tester-player-options></slotcom-tester-player-options>
      }
      @if (activeTab === 'webOptions') {
        <slotcom-tester-web-options></slotcom-tester-web-options>
      }
      @if (activeTab === 'advancedOptions') {
        <slotcom-tester-advanced-options></slotcom-tester-advanced-options>
      }
      @if (activeTab === 'playGamesOptions') {
        <slotcom-tester-play-games-options></slotcom-tester-play-games-options>
      }
    </div>
  </div>
</div>
